
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class inventariosService {

    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    public obtener(inventario: number) {
        return this.httpClient.get(environment.serviceUrl + "documento/" + inventario, { observe: 'response' },)
    }

    obtenerInventario(tipinv: any) {
        this.apiService.setUrlPathApi("tinventario/");
        return this.apiService.execGetQueryJson(`${tipinv}`)
    }
     obtenerCorrelativo(tipinv:any,patron:any){
        this.apiService.setUrlPathApi(`tinventario/${tipinv}/correlativo?`);
        return this.apiService.execGetQueryJson(`patron=${patron}`)
     }
    /*buscarDocumento(codTipoDocumento: any) {
        this.apiService.setUrlPathApi("documento/");
        return this.apiService.execGetQueryJson(`${codTipoDocumento}`)
    }*/

    insertInventario(inventario: any) {
        this.apiService.setUrlPathApi("tinventario");
        return this.apiService.executePostJson(inventario).pipe();
    }

    actualizarInventario(inventario: any) {
        this.apiService.setUrlPathApi("tinventario/");
        return this.apiService.executePutJson(inventario).pipe();
    }

    eliminarInventario(tipinv: any) {
        this.apiService.setUrlPathApi("tinventario/");
        return this.apiService.executeDeleteJson(`${tipinv}`)
    }

    eliminarClase(codigo: any, series: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi("documento/clase/");
        return this.apiService.executeDeleteJson(`${codigo}/${series}/${clase}`)
    }

    obtener_clase(codigo: any, series: any, clase: any): Observable<any> {
        return this.httpClient.get(environment.serviceUrl + "documento/clase/" + codigo + "/" + series + "/" + clase, { observe: 'response' })
    }

    obtener_clases(): Observable<any> {
        this.apiService.setUrlPathApi("documento/clase/buscar");
        return this.apiService.execGetJson();
    }

}